import { render, staticRenderFns } from "./findPwd.vue?vue&type=template&id=732cbc8b&scoped=true"
import script from "./findPwd.vue?vue&type=script&lang=js"
export * from "./findPwd.vue?vue&type=script&lang=js"
import style0 from "./findPwd.vue?vue&type=style&index=0&id=732cbc8b&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732cbc8b",
  null
  
)

export default component.exports